import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Exige sesion de Firebase activa Y que el usuario tenga perfil 'sudo'.
 * Todos los endpoints de keystoreman-console-api lo requieren.
 */
export const authGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const firebaseUser = await authService.waitForAuthReady();
  if (!firebaseUser) return router.createUrlTree(['login']);

  let currentUser = authService.currentUser();
  if (!currentUser) {
    try {
      currentUser = await authService.getUser();
    } catch {
      await authService.signOut(false);
      return router.createUrlTree(['login']);
    }
  }

  if (currentUser.profile !== 'sudo') {
    await authService.signOut(false);
    return router.createUrlTree(['login']);
  }

  return true;
};
